import { MoveRight } from "lucide-react";

const ExamInstructions = ({ onNext } : {onNext: () => void;}) => {
    return (
        <div className="min-h-screen justify-between flex flex-col">
            <div>
                <div className="py-4 bg-[#DCDDDD] px-3">
                    <h1 className="font-bold text-sm">
                        Diploma in International Financial Reporting (IFR - INT) Sample Questions - June 2024
                    </h1>
                </div>
                <div className="bg-[#F2F2F2] h-8 text-" />
            </div>
            <div className="p-5 mb-auto">
                <h1 className="text-xl font-bold">Exam Summary</h1>
                <p className="font-bold my-12">
                    Time Allowed <span className="font-normal">2 hours</span>
                </p>
                <p>
                    <span>This exam contains </span>
                    <b>4 questions</b>
                    <span>&nbsp;worth </span>
                    <b>25 marks</b>
                    <span>&nbsp;each.</span>
                </p>
                <p>
                    <b>100 marks</b>
                    <span>&nbsp;in total.</span>
                </p>
                <p className="mt-8">All questions are compulsory.</p>
                <div className="mt-14">
                    <p className="mb-3">
                        <b>Important</b>
                        <span>:</span>
                    </p>
                    <p className="mb-2">
                        <span>In your live exam, you should:</span>
                    </p>
                    <div className="pl-28 space-y-3">
                        <p>
                            <span>
                                • Enter your answer for each question in the response options provided for that
                                question. Any answers entered into a response option provided for a different
                                question will not be marked.
                            </span>
                        </p>
                        <p>
                            <span>
                                • Indicate which requirement each of your responses relate to so that this is clear for
                                markers.
                            </span>
                        </p>
                        <p>
                            <span>
                                • Show all notes/workings that you want the marker to see within your responses.
                                Remember, any notes/workings made on the Scratch Pad or on your workings paper will
                                not be marked.
                            </span>
                        </p>
                    </div>
                    <p className="mt-14 pb-24 border-b">
                        <span>Click </span>
                        <b>Next</b>
                        <span>&nbsp;to start your exam.</span>
                    </p>
                    <p className="mt-8">
                        <span>
                            This exam makes reference to trade marks which are owned by the IFRS Foundation, and
                            used by ACCA under licence. The IFRS Foundation has trade marks registered around the
                            world including: ‘IAS
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, ‘IASB
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, ISSB™, ‘IFRIC
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, ‘IFRS
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, the IFRS
                        </span>
                        <sup>®</sup>
                        <span>
                            &nbsp;logo, ‘IFRS for SMEs
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, IFRS for SMEs
                        </span>
                        <sup>®</sup>
                        <span>
                            &nbsp;logo, the ‘Hexagon Device’, ‘International Accounting Standards
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, ‘International Financial Reporting Standards
                        </span>
                        <sup>®</sup>
                        <span>
                            ’, ‘NIIF
                        </span>
                        <sup>®</sup>
                        <span>’ and ‘SIC</span>
                        <sup>®</sup>
                        <span>’. Further details of the IFRS Foundation’s trade marks are available from the IFRS Foundation on request.</span>
                    </p>
                </div>
            </div>
            <div className="py-3 bg-[#DCDDDD] px-3">
                <button className="font-bold text-sm flex items-center gap-1 ml-auto" onClick={onNext}>
                    Next <MoveRight />
                </button>
            </div>
        </div>
    );
};

export default ExamInstructions;
